"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNumberHelper = void 0;
class MobileNumberHelper {
    static obfuscate(mobile) {
        if (!mobile) {
            return mobile;
        }
        return this.obfuscateDefined(mobile);
    }
    static obfuscateDefined(mobile) {
        if (mobile === _a.unknownNumber ||
            mobile === "" ||
            mobile.length < 3) {
            return mobile;
        }
        const character = "*";
        return (character.repeat(mobile.length - 3) +
            mobile.substring(mobile.length - 3));
    }
}
exports.MobileNumberHelper = MobileNumberHelper;
_a = MobileNumberHelper;
MobileNumberHelper.unknownNumber = "Unknown";
/**
 * simpler version that returns a boolean for use in the common case
 */
MobileNumberHelper.isValidMobileNumber = (mobile) => !!mobile && _a.validatePhoneNumber(mobile, true) === true;
MobileNumberHelper.replaceStartAndValidate = ({ number, startString, }) => {
    const startsWith = number.startsWith(startString);
    const mobileNumberRegex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/i;
    if (!startsWith) {
        return false;
    }
    const standardised = "+447" + number.slice(startString.length);
    if (standardised.match(mobileNumberRegex)) {
        return true;
    }
    return false;
};
// This validation matches the validation we do on the server in MobileNumberHelper.cs
MobileNumberHelper.validatePhoneNumber = (mobile, validateEmptyMobile, pdsMobile) => {
    // If we are not submitting (aka on blur validation) and there is no value added do not worry about error messages
    if (!validateEmptyMobile && mobile === "") {
        return true;
    }
    if (mobile === "07700900000") {
        return true;
    }
    if (pdsMobile &&
        pdsMobile !== _a.unknownNumber &&
        pdsMobile === mobile) {
        return true;
    }
    if (mobile.match(/[a-zA-Z]/)) {
        return false;
    }
    const numbers = mobile.replace(/\D/g, ""); // Filter out whitespace, brackets, '+' etc.
    switch (numbers.length) {
        case 10: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "7",
            });
        }
        case 11: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "07",
            }); //07*
        }
        case 12: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "447",
            }); //+447*
        }
        case 13: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "4407",
            }); //+44 (0)7*
        }
        case 14: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "00447",
            }); //0044 7*
        }
        case 15: {
            return _a.replaceStartAndValidate({
                number: numbers,
                startString: "004407",
            }); //0044 (0)7*
        }
        default:
            return false;
    }
};
//# sourceMappingURL=MobileNumberHelper.js.map